import { useEffect, useRef, useState } from "react";
import "./Homescreen/HeroSection.css";

const curricula = [
  { title: "IGCSE", subtitle: "International Curriculum", description: "Personalised support for Cambridge IGCSE students.", icon: "IG", accent: "pink" },
  { title: "GCSE", subtitle: "UK Curriculum", description: "Focused learning support for GCSE subjects and exams.", icon: "GC", accent: "purple" },
  { title: "IB MYP", subtitle: "International Baccalaureate", description: "Guidance for students following the IB Middle Years Programme.", icon: "MYP", accent: "pink" },
  { title: "IB DP", subtitle: "International Baccalaureate", description: "Academic support for students following the IB Diploma Programme.", icon: "DP", accent: "purple" },
  { title: "CBSE", subtitle: "Indian Curriculum", description: "Personalised tutoring aligned with the CBSE curriculum.", icon: "CBSE", accent: "purple" },
  { title: "ICSE", subtitle: "Indian Curriculum", description: "Indian certificate for secondary education support.", icon: "ICSE", accent: "pink" },
  { title: "ISC", subtitle: "Indian Curriculum", description: "Flexible subject support for Indian school certificate.", icon: "ISC", accent: "purple" },
  { title: "Career counselling", subtitle: "We counsel", description: "Counselling Students to choose the right career path.", icon: "CC", accent: "pink" },
];

/* ==================== ANIMATED COUNTER ============================ */ 
function AnimatedCounter({
   end, suffix = "", duration = 2200, }) 
   { const [count, setCount] = useState(0); 
  const [started, setStarted] = useState(false); 
  const counterRef = useRef(null); 
  /* Start counter when it becomes visible */ 
  useEffect(() => { const element = counterRef.current; if (!element) return; const observer = new IntersectionObserver( ([entry]) => { if (entry.isIntersecting && !started) { setStarted(true); } }, { threshold: 0.3, } ); observer.observe(element); return () => observer.disconnect(); }, [started]); /* Animate number */ useEffect(() => { if (!started) return; let startTime = null; let animationFrame; const animate = (currentTime) => { if (!startTime) { startTime = currentTime; } const elapsed = currentTime - startTime; const progress = Math.min(elapsed / duration, 1); /* Smooth ease-out */ const easeOut = 1 - Math.pow(1 - progress, 3); const currentValue = Math.floor(easeOut * end); setCount(currentValue); if (progress < 1) { animationFrame = requestAnimationFrame(animate); } else { setCount(end); } }; animationFrame = requestAnimationFrame(animate); return () => cancelAnimationFrame(animationFrame); }, [started, end, duration]); return ( <span ref={counterRef} className="ab4s-stat-number" > {count} {suffix && ( <span className="ab4s-stat-suffix"> {suffix} </span> )} </span> ); } 
/* ===================== HERO SECTION ============================= */

export default function HeroSection() {
  useEffect(() => {
    function TxtRotate(el, words, period) {
      this.el = el; this.words = words; this.i = 0; this.period = parseInt(period, 10) || 1000;
      this.txt = ""; this.deleting = false; this.timeout = null; this.tick();
    }
    TxtRotate.prototype.tick = function () {
      const full = this.words[this.i % this.words.length];
      this.txt = this.deleting ? full.substring(0, this.txt.length - 1) : full.substring(0, this.txt.length + 1);
      this.el.innerHTML = `<span class="ab4s-typing-wrap">${this.txt}</span>`;
      let delta = 250 - Math.random() * 100;
      if (this.deleting) delta /= 2;
      if (!this.deleting && this.txt === full) { delta = this.period; this.deleting = true; }
      else if (this.deleting && this.txt === "") { this.deleting = false; this.i++; delta = 180; }
      this.timeout = setTimeout(() => this.tick(), delta);
    };

    const instances = [];
    document.querySelectorAll(".txt-rotate").forEach((el) => {
      const words = el.getAttribute("data-rotate");
      if (words) instances.push(new TxtRotate(el, JSON.parse(words), el.getAttribute("data-period")));
    });
    return () => instances.forEach(x => x.timeout && clearTimeout(x.timeout));
  }, []);

  return (
    <>
      <section className="ab4s-hero-pink" id="splash">
        <div className="ab4s-hero-decoration ab4s-decoration-one" />
        <div className="ab4s-hero-decoration ab4s-decoration-two" />
        <div className="ab4s-hero-decoration ab4s-decoration-three" />

        <div className="container ab4s-hero-pink-inner">
          <div className="ab4s-hero-pink-content">
            <div className="ab4s-hello-pink">
            <br></br>
              <span className="txt-rotate" data-period="1200"
                data-rotate='["Hello!", "Olá!", "Hallo!", "Salut!", "Ciao!", "Hola!", "Hej!"]' />
            </div>
            <br></br>
            <br></br>
            <div className="ab4s-hero-label"><span className="ab4s-label-dot" />PERSONALISED ONLINE LEARNING</div>

            <h1>
              Welcome to<br />
              <span className="ab4s-brand-pink">AlphaBeta<span>4</span>Success</span>
            </h1>

            <p className="ab4s-hero-description">
              Where expert tutors nurture your children's brilliance through personalised,
              engaging and focused learning.
            </p>

            <div className="ab4s-hero-tagline-pink">
              Unlocking Potential <span>•</span> Igniting Success
            </div>
            <br></br>
            <div className="ab4s-hero-actions-pink">
              <a href="#Contact" className="ab4s-pink-primary-btn">Get in Touch <span>→</span></a>
              <a href="#curricula" className="ab4s-pink-outline-btn">Explore Curricula</a>
            </div>
            <br></br>
            <br></br>         
            
            <div className="ab4s-stats">
            {/* Satisfaction */}
            <div className="ab4s-stat-item">
              <AnimatedCounter
                end={100}
                suffix="%"
                duration={2400}
              />
              <span className="ab4s-stat-label">
              Customer Satisfaction
              </span>
            </div>
            {/* Courses & Subjects */}
            <div className="ab4s-stat-item">
              <AnimatedCounter
                end={20}
                suffix="+"
                duration={2300}
              />
              <span className="ab4s-stat-label">
              Courses & Subjects
              </span>
            </div>
            {/* Curriculum */}
            <div className="ab4s-stat-item">
              <AnimatedCounter
                end={10}
                suffix="+"
                duration={2200}
              />
              <span className="ab4s-stat-label">
              Curriculum Boards
              </span>
            </div>
            {/* Countries Reached */}
            <div className="ab4s-stat-item">
              <AnimatedCounter
                end={10}
                suffix="+"
                duration={2000}
              />
              <span className="ab4s-stat-label">
              Countries Reached
              </span>
            </div>
          </div>
          </div>
          
          <div className="ab4s-hero-pink-visual">
            <div className="ab4s-image-frame">
              <div className="ab4s-image-glow" />
              <img src="/img/meeting5.jpg" alt="Students learning with AlphaBeta4Success" />

              <div className="ab4s-floating-card ab4s-floating-top">
                <div className="ab4s-floating-icon">✦</div>
                <div><strong>Learn with Confidence</strong><span>Expert guidance</span></div>
              </div>
              <div className="ab4s-floating-card ab4s-floating-bottom">
                <div className="ab4s-floating-icon">✓</div>
                <div><strong>Happy Learning!</strong><span>Every step matters</span></div>
              </div>
            </div>
          </div>
        </div>
        <div className="ab4s-hero-wave" />
      </section>

      <section className="ab4s-curricula-pink" id="curricula">
        <div className="ab4s-soft-circle ab4s-circle-left" />
        <div className="ab4s-soft-circle ab4s-circle-right" />

        <div className="container">
          <div className="ab4s-pink-section-heading">
            <span className="ab4s-pink-eyebrow">LEARNING PATHWAYS</span>
            <h2>Choose Your <span>Curriculum<i /></span></h2>
            <p>
              Personalised tutoring designed to help students learn with confidence,
              build strong foundations and achieve their goals.
            </p>
          </div>

          <div className="ab4s-pink-board-grid">
            {curricula.map((board, index) => (
              <a href="#Contact" key={board.title}
                className={`ab4s-pink-board-card ${board.accent}`}
                style={{ "--card-index": index }}>
                <div className="ab4s-card-number">0{index + 1}</div>
                <div className="ab4s-pink-board-icon">{board.icon}</div>
                <div className="ab4s-pink-board-content">
                  <span>{board.subtitle}</span>
                  <h3>{board.title}</h3>
                  <p>{board.description}</p>
                </div>
                <div className="ab4s-pink-board-arrow">→</div>
              </a>
            ))}
          </div>

          <div className="ab4s-pink-bottom-cta">
            <div className="ab4s-cta-star">✦</div>
            <div className="ab4s-cta-text">
              <strong>Every child learns differently.</strong>
              <span>Let us create a learning experience that works for your child.</span>
            </div>
            <a href="#Contact">Talk to AB4S team <span>→</span></a>
          </div>
        </div>
      </section>
    </>
  );
}
